import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import HeroSection from './sections/HeroSection';
import PricingSection from './sections/PricingSection';
import ProcessSection from './sections/ProcessSection';
import WhoWeServeSection from './sections/WhoWeServeSection';
import CredentialsSection from './sections/CredentialsSection';
import CTASection from './sections/CTASection';
import Testimonials from '../../components/common/Testimonials';
import FAQ from '../../components/common/FAQ';
import FloatingWhatsApp from '../../components/common/FloatingWhatsApp';

const homeTestimonials = [
  { quote: "Good Auditor and very reliable.", name: "Nawshadarakkal Arakkal", meta: "Broadway · Google review" },
  { quote: "Clear advice on our corporate tax position and very responsive throughout.", name: "Client review", meta: "Google review" },
  { quote: "They prepared our return and explained every adjustment. Highly recommended.", name: "Client review", meta: "Google review" },
];

const homeFAQs = [
  { q: "When did Corporate Tax start in the UAE?", a: "UAE Corporate Tax applies to financial years starting on or after 1 June 2023. If your business hasn't assessed its position yet, every extra month can add to your compliance exposure — we can advise on where you stand." },
  { q: "Who actually has to pay it?", a: "Most UAE businesses with taxable profits above AED 375,000 are subject to Corporate Tax. Exemptions and reliefs exist — we assess your specific eligibility as part of our advisory work." },
  { q: "What's the actual tax rate?", a: "0% on taxable income up to AED 375,000 and 9% above that threshold. Certain qualifying free zone income may be taxed differently — this is exactly what our eligibility assessment covers." },
  { q: "Are free zone companies exempt?", a: "Not automatically. Qualifying Free Zone Persons can benefit from a 0% rate on qualifying income, but strict conditions apply. We review your activities and advise whether you qualify." },
  { q: "What happens if a return is filed late?", a: "Late filing attracts administrative penalties that grow over time. We help you prepare accurate returns well ahead of deadlines so you or your authorized signatory can submit on time." },
  { q: "Is Standard Auditing a government body?", a: "No. We are an independent private consulting firm. We advise, prepare, and review — all filings are submitted by you or your authorized signatory through the relevant government portals." },
];

const AuditTaxConsulting = () => {
  return (
    <div style={{ minHeight: '100vh', background: '#FBFAF6', display: 'flex', flexDirection: 'column' }}>
      <Helmet>
        <title>Standard Auditing — Independent Corporate Tax &amp; Audit Advisory, Dubai</title>
        <meta name="description" content="Independent private tax and audit consulting firm based in Dubai, UAE. We offer eligibility assessments, return preparation, and corporate tax compliance advisory." />
        <link rel="canonical" href="https://audit-tax-consulting.standardauditors.com/" />
      </Helmet>
      
      <Header />
      
      <main style={{ flex: 1 }}>
        <HeroSection />
        
        <PricingSection />
        
        <ProcessSection />
        
        <WhoWeServeSection />
        
        <CredentialsSection />
        
        {/* Testimonials Slide Section */}
        <section data-screen-label="Testimonials" style={{ padding: '72px 48px', background: '#F3F0E7', textAlign: 'center' }}>
          <div style={{ maxWidth: '760px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '28px', alignItems: 'center' }}>
            <h2 style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 'clamp(22px, 4vw, 32px)', color: '#26332C', margin: 0, fontWeight: 800 }}>
              What Our Clients Say
            </h2>
            <p style={{ margin: 0, fontSize: '15px', color: '#5C574C' }}>
              Real Google reviews from UAE businesses that trust Standard Auditing.
            </p>
            <Testimonials testimonials={homeTestimonials} variant="sa" />
          </div>
        </section>
        
        {/* FAQ Section */}
        <section data-screen-label="FAQ" style={{ padding: '72px 48px', background: '#FBFAF6', textAlign: 'center' }}>
          <div style={{ maxWidth: '760px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '28px', alignItems: 'center' }}>
            <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <h2 style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 'clamp(22px, 4vw, 32px)', color: '#26332C', margin: 0, fontWeight: 800 }}>
                Frequently Asked Questions
              </h2>
              <p style={{ margin: 0, fontSize: '15px', color: '#5C574C' }}>
                The questions UAE businesses ask us most about Corporate Tax.
              </p>
            </div>
            <FAQ faqs={homeFAQs} variant="sa" />
          </div>
        </section>
        
        <CTASection />
      </main>
      
      <Footer />

      <FloatingWhatsApp />
    </div>
  );
};

export default AuditTaxConsulting;
